module.exports = __webpack_public_path__ + "img/artillery-wagon-cannon-barrel-5.ccc38f1a.png";